var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 95,
    viewBox: "0 0 355 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05557 52.2353C21.2993 47.4825 36.4996 46.6201 49.6667 44.9133C102.597 38.0519 156.419 34.3393 210.233 34.9325C255.144 35.4276 301.01 37.2937 345.721 43.0292",
    stroke: "#FFC738",
    strokeWidth: 17,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderLine2);
export default __webpack_public_path__ + "static/media/under_line2.64dbd17bcfc6b5b48e1d83270743dbee.svg";
export { ForwardRef as ReactComponent };